import { CommonActionType } from '../common/common-actions';
export const SubscriptionActionType = {
    ...CommonActionType,
    LOAD_SUBSCRIPTIONS: 'LOAD_SUBSCRIPTIONS',
    LOAD_SUBSCRIPTIONS_SUCCESS: 'LOAD_SUBSCRIPTIONS_SUCCESS',
    LOAD_SUBSCRIPTIONS_ERROR: 'LOAD_SUBSCRIPTIONS_ERROR',
    CHECK_FEATURE_ERROR: 'CHECK_FEATURE_ERROR',
};
